export default {
  location: [1, 2],
  pcBgColor: '#ffffff',
  pathLink: [],
  autoPlay: true,
  autoPlayTime: 3,
  pcHeight: 300,
  mHeight: 196,
  vertical: false
};